export default __webpack_public_path__ + "static/media/dublin-airport.3a28accf.svg";